export const filterSearchString = v => v.replace(/[\^`{}\]\\[|]+/g, '')
